import { canPlayUiSfx, playSfxFile, preloadUiSfx } from './audioSettings';

// Yumuşak, kısa tık (eski tekbutonses.mp3 sert ve uzundu).
const BUTTON_CLICK_SOUND = '/sounds/ui_tik_yumusak.wav';
const POINT_INCREASE_SOUND = '/sounds/puanartirmasesi.mp3';
const ARTI_BAS_SOUND = '/sounds/artibasmasesi.mp3';
const ENHANCE_SUCCESS_SOUND = '/sounds/basarili.mp3';
const ENHANCE_FAIL_SOUND = '/sounds/basarisiz.mp3';

// Giriş ve ana menü ekranlarında tıklama sesi çalınmaz.
const SILENT_CLICK_PATHS = new Set(['/', '/login', '/register', '/intro', '/game', '/character-selection', '/ability-type-selection']);

export function preloadButtonSounds() {
  preloadUiSfx([BUTTON_CLICK_SOUND, ENHANCE_SUCCESS_SOUND, ENHANCE_FAIL_SOUND]);
}

/** UI buton tıklama sesi (dosya yoksa sessiz). */
export function playButtonClickSound(volume = 0.45) {
  playSfxFile(BUTTON_CLICK_SOUND, volume, 'ui');
}

/** Gelişim ekranı stat / skill puanı artırma sesi. */
export function playPointIncreaseSound(volume = 0.7) {
  playSfxFile(POINT_INCREASE_SOUND, volume, 'ui');
}

/** Köy enhancement — Artı Bas sesi. */
export function playArtiBasSound(volume = 0.7) {
  playSfxFile(ARTI_BAS_SOUND, volume, 'ui');
}

/** Enhancement başarılı (+1). */
export function playEnhanceSuccessSound(volume = 0.75) {
  playSfxFile(ENHANCE_SUCCESS_SOUND, volume, 'ui');
}

/** Enhancement başarısız (item yandı). */
export function playEnhanceFailSound(volume = 0.75) {
  playSfxFile(ENHANCE_FAIL_SOUND, volume, 'ui');
}

/** Craft başarılı: başarı sesi. */
export function playCraftSuccessSound(volume = 0.7) {
  playSfxFile(ENHANCE_SUCCESS_SOUND, volume, 'ui');
}

/** Craft başarısız: belirgin ama daha kısık başarısızlık sesi. */
export function playCraftFailSound(volume = 0.5) {
  playSfxFile(ENHANCE_FAIL_SOUND, volume, 'ui');
}

export function shouldPlayButtonClickSound(button, pathname) {
  if (!canPlayUiSfx()) return false;
  if (!button || button.disabled) return false;
  if (SILENT_CLICK_PATHS.has(pathname)) return false;
  if (button.getAttribute('data-silent-click') === 'true') return false;
  if (pathname === '/battle') {
    return Boolean(button.closest('.battle-nav-row'));
  }
  return true;
}

// Soket taşları: düşme, takma ve birleştirme sesleri.
const GEM_DROP_SOUND = '/sounds/stone/gem_drop.wav';
const GEM_INSERT_SOUND = '/sounds/stone/gem_insert.wav';
const GEM_CRAFT_SOUND = '/sounds/stone/gem_craft.wav';

/** others id'si soket taşı mı (değerli taş 2001-2024, rune 2101-2128). */
export function isSocketStoneOtherId(id) {
  const n = Number(id);
  return (n >= 2001 && n <= 2024) || (n >= 2101 && n <= 2128);
}

/** Eşya listesinde taş varsa taş düşme sesini çalar. */
export function playGemDropSoundIfAny(items, volume = 0.75) {
  if ((items || []).some((it) => it && (it.itemType === 'other' || it.itemType === 'others') && isSocketStoneOtherId(it.itemId))) {
    playSfxFile(GEM_DROP_SOUND, volume, 'ui');
  }
}

export function playGemInsertSound(volume = 0.8) {
  playSfxFile(GEM_INSERT_SOUND, volume, 'ui');
}

export function playGemCraftSound(volume = 0.75) {
  playSfxFile(GEM_CRAFT_SOUND, volume, 'ui');
}
